var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "gate",
      class: "gate--" + _vm.band.kind,
      attrs: { role: _vm.live ? "status" : "note" },
    },
    [
      _c(
        "i",
        { staticClass: "material-icons", attrs: { "aria-hidden": "true" } },
        [_vm._v(_vm._s(_vm.band.icon))]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "gate__body" }, [
        _c("p", { staticClass: "gate__title" }, [
          _vm._v(_vm._s(_vm.band.title)),
        ]),
        _vm._v(" "),
        _c("p", { staticClass: "gate__detail" }, [
          _vm._v(_vm._s(_vm.band.detail)),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }